export const VOUCHER_RULE_TYPE = {
     MIN_CART_VALUE: 'minCartValue',
     LIMIT_ON_PRODUCTS: 'limitOnProducts',
};

export const VOUCHER_RULE_TYPE_MAPPER = {
     minCartValue: 'Minimum Cart Amount',
     limitOnProducts: 'Purchase specific product(s)',
};

export const VOUCHER_RULE_TYPES = [
     { id: 'minCartValue', name: 'Minimum Cart Amount' },
     { id: 'limitOnProducts', name: 'Purchase specific product(s)' },
];

export const VOUCHER_APPLY_FOR = {
     BOTH: 'BOTH',
     INDIVIDUAL: 'INDIVIDUAL',
     ORGANIZATION: 'ORGANIZATION',
};

export const VOUCHER_APPLY_FOR_ARR = [
     { id: 'BOTH', name: 'Both' },
     { id: 'INDIVIDUAL', name: 'Individual' },
     { id: 'ORGANIZATION', name: 'Organization' },
];

export const VOUCHER_RULE_EXPIRATION_TYPE = {
     EXPIRES_AFTER_DATE: 'expiresAfterDate',
     EXPIRATION_DATE: 'codeExpirationDate',
};

export const VOUCHER_RULE_EXPIRATION_TYPES = [
     { id: 'expiresAfterDate', name: 'Expire after X days' },
     { id: 'codeExpirationDate', name: 'Expire on specific day' },
];

export const VOUCHER_CART_TYPE = {
     DISCOUNT_ON_CART: 'DISCOUNT_ON_CART',
     DISCOUNT_ON_PRODUCT: 'DISCOUNT_ON_PRODUCT',
};

export const CART_TYPE_MAPPER = {
     DISCOUNT_ON_CART: 'Discount on cart',
     DISCOUNT_ON_PRODUCT: 'Discount on product(s)',
};

export const VOUCHER_CART_TYPES = [
     { id: 'DISCOUNT_ON_CART', name: 'Apply Discount to Cart ' },
     { id: 'DISCOUNT_ON_PRODUCT', name: 'Apply Discount to a Specific Product' },
];

export const VOUCHER_STATUS = {
     OPEN: 'OPEN',
     USED: 'USED',
     EXPIRED: 'EXPIRED',
};

export const VOUCHER_STATUSES = [
     { id: 'OPEN', name: 'Open' },
     { id: 'USED', name: 'Used' },
     { id: 'EXPIRED', name: 'Expired' },
];
